import { PollingFrequencyFormObject } from "../PollingFrequencyUtils";

const PollingFrequencyObjectListUtils = {

    filterItems: (data: PollingFrequencyFormObject[], 
        filter: string,
        viewSelected: boolean,
    ) : PollingFrequencyFormObject[] => {

        let items = viewSelected ? data.filter(o => o.selected) : data;

        items = items.filter(o => (filter.trim() === '' ||
                                o.label.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1));


        return items;                                
    }        
}

export default PollingFrequencyObjectListUtils;
